import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spacing.sp32};
  padding: ${props => props.theme.spacing.sp32} 0;

  img {
    height: 100px;
    width: 100px;
  }
`

export const TextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  text-align: center;
`
